import 'prism-themes/themes/prism-vs.css';
//import 'prism-themes/themes/prism-atom-dark.css';
import React from 'react';
import 'react-diff-view/style/index.css';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import NoResultsText from '../../../common/NoResultsText';
import DiffPanel from './DiffPanel';
//import './DiffViewDarkTheme.css';

interface Props {
  files: any[];
  refs: object;
}

function DiffFilesList(props: Props & RouteComponentProps<any>) {
  const { files, refs } = props;
  return (
    <div>
      {files.map(file => <div
        key={file.id}
        ref={refs[file.id]}>
        <DiffPanel file={file} />
      </div>)}
      {files.length === 0 && <NoResultsText>No changes matching filters</NoResultsText>}
    </div>
  );
};

export default withRouter(DiffFilesList);
